import { render } from "./UploadSpeak.vue?vue&type=template&id=f409fff8&scoped=true"
import script from "./UploadSpeak.vue?vue&type=script&lang=js"
export * from "./UploadSpeak.vue?vue&type=script&lang=js"

import "./UploadSpeak.vue?vue&type=style&index=0&id=f409fff8&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-f409fff8"

export default script